import React from "react";
import { Col, Image } from "react-bootstrap";
// import SelectSearch from "react-select";
import Select from "react-select";

export default ({
  itemArray,
  value,
  onToggle,
  show,
  dropdownTitle,
  ishideArrow,
  dropdowndefaultValue,
  style,
  iconPre,
  titleAlign,
  dropdownTitleWithImage,
  disabled,
  onSelect,
  options,
}) => {
  return (
    <Col
      lg={12}
      md={12}
      sm={12}
      xs={12}
      style={{
        padding: "0%",
        fontSize: style?.fontSize ? style.fontSize : "",
      }}
      className="commonDrop-search-Col"
    >
      {dropdownTitle ? (
        <div
          className="commonDrop-head flex-between-center"
          style={{
            marginBottom: style?.titleheadMarginBottom
              ? style.titleheadMarginBottom
              : "",
            ...style?.headTitleStyle,
          }}
        >
          <div className="dropdowntitle">{dropdownTitle}</div>
          {dropdownTitleWithImage?.length ? (
            <div className="dropdowntitleimg">
              {dropdownTitleWithImage.map((img) => (
                <Image src={img} />
              ))}
            </div>
          ) : null}
        </div>
      ) : (
        ""
      )}
      <div
        style={{
          height: style?.height ? style.height : "",
          marginBottom: "1rem",
        }}
      >
        <Select  onChange={onSelect} options={options} defaultInputValue={value} placeholder={dropdowndefaultValue}/>
      </div>
    </Col>
  );
};
